const theme = {
  id: "blue",
  name: "الأزرق",
  header: {
    h1: {
      color: "#fff",
      fontSize: 32,
      fontStyle: "normal",

      fontFamily: "ReemKufi-Regular",
    },
    h2: {
      color: "#ccc",
      fontSize: 16,
      fontStyle: "normal",

      fontFamily: "Tajawal-Regular",
    },
    texture: "background-0",

    backgroundColor: "#184AAD",
  },
  note: {
    header: {
      texture: "background-0",

      backgroundColor: "#0F2F6E",
      text: {
        color: "#fff",
        fontSize: 16,
        fontStyle: "normal",

        fontFamily: "Tajawal-Regular",
        contents: "",
      },
    },
    body: {
      texture: "background-1",
      backgroundColor: "#ddd",
      text: {
        color: "#fff",
        fontStyle: "normal",

        fontSize: "24px",
        fontFamily: "Tajawal-Regular",
        contents: "",
      },
    },
  },
  main: {
    weekHeader: {
      texture: "background-0",

      backgroundColor: "#0F2F6E",
      text: {
        color: "#fff",
        fontSize: 16,
        fontFamily: "Tajawal-Regular",
        fontStyle: "normal",
        contents: "",
      },
    },
    blockActive: { backgroundColor: "white", borderColor: "gray" },
    blockUnActive: { backgroundColor: "#184AAD" },
    withBorderDays: true,
  },
  images: {
    "image-top-right": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-center-right": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-center-left": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-top-left": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-bottom-right": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
  },
};
export default theme;
